<template>
	<div class="conversation-list" :open-dialog="openDialog">
		<template v-if="getAllConversations.length === 0">
			<div
				v-for="i in 3"
				class="conversation-list-item conversation-list-item-sample card"
				:key="'conversation-sample_' + i"
			>
				<div class="conversation-avatar-container">
					<button
						class="conversation-avatar btn action flat rounded"
					></button>
				</div>
				<div class="content">
					<span class="title_timestamp">
						<span class="title clr-secondary">
							<div
								class="sampletext bgclr-secondary"
								style="width: 128px;"
							></div>
						</span>
						<span class="timestamp">
							<div
								class="sampletext bgclr-light"
								style="width: 64px;"
							></div>
						</span>
					</span>
					<span class="last-message_conversation-action">
						<span class="last-message">
							<span class="username">
								<div
									class="sampletext bgclr-dark"
									style="width: 96px;"
								></div>
								&nbsp;
							</span>
							<span class="body">
								<div
									class="sampletext bgclr-dark"
									style="width: 128px;"
								></div>
							</span>
						</span>
						<span class="conversation-action"></span>
					</span>
				</div>
			</div>
		</template>
		<template v-else>
			<ConversationListItem
				v-for="conversation in getAllConversations"
				@update:conversationInfoOpen="
					updateConversationInfoOpen($event)
				"
				:conversation="conversation"
				:active="
					!!getCurConversation &&
						conversation.providerName ==
							getCurConversation.providerName &&
						conversation.id == getCurConversation.id
				"
				:key="
					'conversation_' +
						conversation.providerName +
						'_' +
						conversation.id
				"
			/>
		</template>
		<ConversationListActions
			@update:openDialog="setOpenDialog"
			:scrolledToBottom="scrolledToBottom"
		/>
	</div>
</template>

<script>
import ConversationListItem from './ConversationListItem.vue';
import ConversationListActions from './ConversationListActions.vue';
import { mapGetters } from 'vuex';

let ticking = false;

export default {
	name: 'ConversationList',
	components: {
		ConversationListItem,
		ConversationListActions
	},
	data() {
		return {
			openDialog: '',
			scrolledToBottom: false
		};
	},
	mounted() {
		this.$el.addEventListener('scroll', () => {
			this.scrollUpdater();
		});
		this.$nextTick(() => {
			this.scrollUpdater();
		});
	},
	computed: {
		...mapGetters({
			getAllConversations: 'ConversationProviders/getAllConversations',
			getCurConversation: 'ConversationProviders/getCurConversation'
		})
	},
	methods: {
		setOpenDialog(to = '') {
			this.openDialog = to;
			this.$emit('update:openDialog', this.openDialog);
		},
		scrollUpdater() {
			let last_known_scroll_position = this.$el.scrollTop;

			if (!ticking) {
				window.requestAnimationFrame(() => {
					if (
						last_known_scroll_position >=
						this.$el.scrollHeight - this.$el.clientHeight - 25
					) {
						this.scrolledToBottom = true;
					} else {
						this.scrolledToBottom = false;
					}

					ticking = false;
				});

				ticking = true;
			}
		},
		updateConversationInfoOpen(to = false) {
			this.$emit('update:conversationInfoOpen', !!to);
		}
	}
};
</script>
